import React from 'react';
import { weddingInvitationsPageData } from '@data-ts/pages/wedding-invitations';
import {
  SectionContainer,
  TextPairingContainer,
  ImageTextPairingContainer,
  BorderdCircle,
  StyledTextImageColumn,
  StyledTextPairFlex,
  StyledCloudImage,
  StyledTextImageLeftColumn,
} from './InvitationsReimaginedSection.styles';
import { Columns } from '@components/Columns';
import { Button } from '@components/Button';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import ReactHtmlParser from 'react-html-parser';

export const InvitationsReimaginedSection: React.FC = () => {
  const { invitationsReimaginedSection } = weddingInvitationsPageData;
  const sectionId = 'InvitationsReimaginedSection';
  return (
    <SectionContainer paddingY={[12]} backgroundColor="humana1Light" id={sectionId}>
      <Columns centered>
        <Columns.Column width={12}>
          <StyledTextPairFlex flexDirection="column">
            <TextPairingContainer
              eyebrow={invitationsReimaginedSection.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant={'sectionEyeBrow20'}
              eyebrowTagName="h3"
              alignment={'center'}
              title={invitationsReimaginedSection.title}
              titleVariant={'hed72Hero'}
              titleColor="neutra6"
              titleTagName="h2"
              body={invitationsReimaginedSection.body}
              bodyColor="neutra5"
              bodyVariant="dek20"
            />
            <Box marginTop={[8]}>
              <Button id="invitationsReimaginedGetStarted" variant="secondary" forwardedAs={'a'} href={getCreateWeddingUrl('online-rsvp')}>
                {invitationsReimaginedSection.getStarted}
              </Button>
            </Box>
          </StyledTextPairFlex>
        </Columns.Column>
      </Columns>
      <StyledTextImageColumn marginTop={[12]} verticalAlign="center" centered>
        <Columns.Column width={4}>
          <BorderdCircle marginTop={[6, 0]} marginBottom={[4]}>
            <Text tagName="span" color="neutra3" variant="sectionEyeBrow24">
              {invitationsReimaginedSection.createInvite.eyebrow}
            </Text>
          </BorderdCircle>
          <ImageTextPairingContainer
            title={invitationsReimaginedSection.createInvite.title}
            titleVariant={'sectionEyeBrow20'}
            titleColor="neutra6"
            titleTagName="h3"
            body={ReactHtmlParser(invitationsReimaginedSection.createInvite.body)}
            bodyColor="neutra5"
            bodyVariant="featureCopy17"
          />
        </Columns.Column>
        <Columns.Column offset={1} width={4}>
          <StyledCloudImage src={invitationsReimaginedSection.createInvite.imageUrl} />
        </Columns.Column>
      </StyledTextImageColumn>
      <StyledTextImageLeftColumn marginTop={[10]} verticalAlign="center" centered>
        <Columns.Column width={4}>
          <StyledCloudImage src={invitationsReimaginedSection.guestList.imageUrl} />
        </Columns.Column>
        <Columns.Column offset={1} width={4}>
          <BorderdCircle marginTop={[6, 0]} marginBottom={[4]}>
            <Text tagName="span" color="neutra3" variant="sectionEyeBrow24">
              {invitationsReimaginedSection.guestList.eyebrow}
            </Text>
          </BorderdCircle>
          <ImageTextPairingContainer
            title={invitationsReimaginedSection.guestList.title}
            titleVariant={'sectionEyeBrow20'}
            titleColor="neutra6"
            titleTagName="h3"
            body={invitationsReimaginedSection.guestList.body}
            bodyColor="neutra5"
            bodyVariant="featureCopy17"
          />
        </Columns.Column>
      </StyledTextImageLeftColumn>
      <StyledTextImageColumn marginTop={[10]} verticalAlign="center" centered>
        <Columns.Column width={4}>
          <BorderdCircle marginTop={[6, 0]} marginBottom={[4]}>
            <Text tagName="span" color="neutra3" variant="sectionEyeBrow24">
              {invitationsReimaginedSection.finallyRSVP.eyebrow}
            </Text>
          </BorderdCircle>
          <ImageTextPairingContainer
            title={invitationsReimaginedSection.finallyRSVP.title}
            titleVariant={'sectionEyeBrow20'}
            titleColor="neutra6"
            titleTagName="h3"
            body={invitationsReimaginedSection.finallyRSVP.body}
            bodyColor="neutra5"
            bodyVariant="featureCopy17"
          />
        </Columns.Column>
        <Columns.Column offset={1} width={4}>
          <StyledCloudImage src={invitationsReimaginedSection.finallyRSVP.imageUrl} />
        </Columns.Column>
      </StyledTextImageColumn>
    </SectionContainer>
  );
};
